/**
 * Allowlist sanitizers — these are UX guards.
 * The real injection protection lives server-side (HTML escaping in the email).
 * Build regexes via new RegExp() to avoid the visual-edits babel plugin tripping
 * on regex literals containing backticks/backslashes.
 */
const NAME_RE = new RegExp("[^A-Za-z\\u00C0-\\u024F\\s'.\\-]", "g");
const PHONE_RE = new RegExp("[^\\d+()\\-.\\s]", "g");
const EMAIL_RE = new RegExp("[^A-Za-z0-9@._\\-+]", "g");
const MESSAGE_RE = new RegExp("[<>{}\\\\`]", "g");

export const sanitizeName = (v) => v.replace(NAME_RE, '').slice(0, 80);
export const sanitizePhone = (v) => v.replace(PHONE_RE, '').slice(0, 25);
export const sanitizeEmail = (v) => v.replace(EMAIL_RE, '').slice(0, 120);
export const sanitizeMessage = (v) => v.replace(MESSAGE_RE, '').slice(0, 2000);

export const FIELD_SANITIZERS = {
  name: sanitizeName,
  email: sanitizeEmail,
  phone: sanitizePhone,
  message: sanitizeMessage,
};
